module.exports = __webpack_public_path__ + "img/pool.438598b2.png";